import React from "react";
import { Operand } from "@merrie/nmbrs-api";
import { OperandUtils } from "@merrie/nmbrs-utils";

export interface IOperandProperties {
  operand: Operand;
  total?: boolean;
}

export const OperandComponent: React.FC<IOperandProperties> = ({
  operand,
  total = true,
}) => (
  <span className={"operand"}>{OperandUtils.toString(operand, total)}</span>
);
